import * as React from 'react';
import { fillLegacyProps } from '../utils/legacyUtil';
export default (treeData, searchValue, { treeNodeFilterProp, filterTreeNode, fieldNames }) => {
    const { children: fieldChildren } = fieldNames;
    return React.useMemo(() => {
        if (!searchValue || filterTreeNode === false) {
            return treeData;
        }
        let filterOptionFunc;
        if (typeof filterTreeNode === 'function') {
            filterOptionFunc = filterTreeNode;
        }
        else {
            const upperStr = searchValue.toUpperCase();
            filterOptionFunc = (_, dataNode) => {
                const value = dataNode[treeNodeFilterProp];
                return String(value).toUpperCase().includes(upperStr);
            };
        }
        function dig(list, keepAll = false) {
            return list
                .map(dataNode => {
                const children = dataNode[fieldChildren];
                const match = keepAll || filterOptionFunc(searchValue, fillLegacyProps(dataNode));
                const childList = dig(children || [], match);
                if (match || childList.length) {
                    return Object.assign(Object.assign({}, dataNode), { isLeaf: undefined, [fieldChildren]: childList });
                }
                return null;
            })
                .filter(node => node);
        }
        return dig(treeData);
    }, [treeData, searchValue, fieldChildren, treeNodeFilterProp, filterTreeNode]);
};
